/* eslint-disable max-len */
export const dictionary = {
  Loading: 'Carregando',
  'Policy and Privacy Terms': 'Termos de Política e Privacidade',
  'Terms of Use': 'Termos de Uso',
  'Change Game': 'Mudar de Jogo',
  PrivacyPolicy: 'Política de privacidade',
  'Game Journey': 'Jornada do Game',
  'I agree with': 'Eu concordo com a',
  "Engagers Game's": 'da Engagers Game',
  'Enter here': 'Digite aqui',
  'Register below': 'Registre abaixo',
  'Register here': 'Registre aqui',
  'Click here': 'Clique aqui',
  Close: 'Fechar',
  'Enter your password to continue': 'Digite a senha para prosseguir',
  'Wrong password': 'Usuário / Senha incorretos',
  'Start the mission here': 'Inicie aqui a missão',
  'Follow the score here': 'Acompanhe a pontuação aqui',
  'The time will appear centered when starting the mission': 'Ao iniciar a missão o tempo irá aparecer centralizado',
  'Enlarge the image if necessary': 'Amplie a imagem se precisar',
  'Send photo': 'Enviar foto',
  'Take photo': 'Tirar foto',
  'Drag or paste your photo here': 'Arraste ou cole sua foto aqui',
  'Choose photo': 'Escolher foto',
  'Photo caption': 'Legenda da imagem',
  'Select below': 'Selecione abaixo',
  'alternative(s)': 'alternativa(s)',
  Blocked: 'Bloqueada',
  Done: 'Pronto',
  'See missions': 'Visualizar missões',
  Gallery: 'Galeria de imagens',
  Instructions: 'Instrucões',
  Points: 'Pontos',
  'Recovery game': 'Recuperar game',
  'Audio: on/off': 'Som: on/off',
  "Your browser don't support HTML5": 'Seu navegador não suporta HTML5',
  "Couldn't load instructions": 'Não foi possível carregar as instruções',
  Team: 'Time',
  Mission: 'Missão',
  PhotoMission: 'Missão de Foto',
  PhotoMissionInstructionOne: 'Clique no botão câmera para fazer o upload da imagem desejada.',
  PhotoMissionInstructionTwo: 'Se quiser, escreva uma legenda para foto na caixa logo abaixo da imagem carregada.',
  PhotoMissionInstructionThree: 'Clique no botão no canto inferior direito para completar a missão.',
  PhotoMissionInstructionDesktop: 'Arraste imagens ou cole prints da tela no input maior.',
  TeamName: 'Nome do Time',
  OpenAnswer: 'Resposta aberta',
  OpenAnswerInstructionOne: 'Insira a sua resposta na caixa escrito “Digite aqui...” e depois clique no botão no canto inferior direito para enviar a sua resposta.',
  ConnectDots: 'Ligue os Pontos',
  ConnectDotsInstructionOne: 'Selecione com um clique a opção da coluna (A) e depois selecione na coluna (B) qual opção ela se conecta.',
  SimpleText: 'Texto simples',
  SimpleTextInstructionOne: 'Após a leitura da tela, clique no botão no canto inferior direito para seguir em frente.',
  MultipleChoice: 'Múltipla Escolha',
  MultipleChoiceInstructionOne: 'Clique na seta no canto direito da barra para ver o texto completo da alternativa, quando houver.',
  MultipleChoiceInstructionTwo: 'Clique em cima da barra com a alternativa que deseja selecionar.',
  MultipleChoiceInstructionThree: 'Para enviar a resposta, clique no botão no canto inferior direito.',

  Welcome: 'Bem-vindo(a)!',
  'Login to access the game': 'Faça seu login para acessar o game',
  'Sign in with Google': 'Acesse com o Google',
  Password: 'Senha',
  'Enter with your E-mail': 'Entre com seu E-mail',
  'Enter with the password': 'Entre com a senha',
  Access: 'Acessar',
  'Forgot your password?': 'Esqueci minha senha',
  'Need help?': 'Estou com dúvidas',
  'Required field': 'Campo obrigatório',
  'E-mail is required': 'E-mail é obrigatório',
  'E-mail is invalid': 'E-mail é invalido',
  'Password is required': 'Senha é obrigatória',
  'Password must have 8 characters at least': 'Senha precisa ter no mínimo 8 caracteres',
  'Password must have 1 number at least': 'Senha precisa ter no mínimo um número',
  'Password must have 1 lowercase letter at least': 'Senha precisa ter no mínimo uma letra minúscula',
  'Password must have 1 uppercase letter at least': 'Senha precisa ter no mínimo uma letra maiúscula',
  'Password must have 1 special character at least': 'Senha precisa ter no mínimo um caractere especial',
  'New Password': 'Nova Senha',
  'Changing...': 'Alterando...',
  Change: 'Alterar',
  'Change your name': 'Altere o seu nome',
  'Change your password': 'Altere a sua senha',
  'Tell us what would you like to be called?': 'Nos diga como você gostaria de ser chamado? Este nome estará vinculado com as suas respostas no Feed.',
  'Your name': 'Seu nome',
  "Your game hasn't started yet.": 'Seu game ainda não foi iniciado.',
  'Your game is now finished.': 'Seu game já foi finalizado.',
  'Check your game date': 'Verifique a data do jogo e tente novamente.',
  'There is no game for you yet.': 'Ainda não existe game pra você.',
  Finish: 'Tudo pronto !!!',
  'Start playing': 'Começar a jogar',
  'As this is your first access, you must change your password for your best security!': 'Como esse é o seu primero acesso, você deve alterar a sua senha para sua maior segurança!',
  PasswordRules: 'A sua senha precisa ter no mínimo <span>8 caracteres</span> com ao menos <span>1 letra maiúscula</span>, <span>1 letra minúscula</span>, <span>1 número</span> e <span>1 caractere especial</span>',
  'No missions until now': 'Sem missões até o momento',
  'Good! You finished all available missions!': 'Boa! Você cumpriu todas as missões disponíveis!',
  'These are your missions for today:': 'Essas são suas missões de hoje:',
  'Finished missions': 'Missões finalizadas',
  'Allowed missions': 'Missões disponíveis',
  Home: 'Início',
  More: 'Mais',
  'Change Password': 'Alterar Senha',
  'Current Password': 'Senha Atual',
  'Confirm New Password': 'Confirmar Nova Senha',
  Save: 'Salvar',
  Saving: 'Salvando',
  'Password updated successfully!': 'Senha atualizada com sucesso!',
  'Sign Out': 'Sair',
  'Do you really want to sign out?': 'Deseja realmente sair?',
  Yes: 'Sim',
  No: 'Não',
  'Recovery Password': 'Recuperar Senha',
  Code: 'Código',
  'Enter the code': 'Digite o código',
  'Send code': 'Enviar código',
  Sending: 'Enviando',
  'Enter the new password': 'Digite a nova senha',
  'Confirm the new password': 'Confirme a nova senha',
  'Password recovered successfully!': 'Senha recuperada com sucesso!',
  'Try again': 'Tente novamente',
  'Send us a message': 'Nos envie uma messagem',
  Name: 'Nome',
  Game: 'Jogo',
  Message: 'Mensagem',
  Send: 'Enviar',
  'Your message was sent. We will reply to you by e-mail shortly.': 'Sua mensagem foi enviada. Em breve responderemos você por e-mail.',
  Document: 'Documento',
  ForgotPasswordSuccess: 'Os dados de recuperação foram enviados para o seu e-mail. Verifique e efetue o login.',
  'Go to Login': 'Ir para o Login',

  AlertSendAnswer: 'Erro ao enviar sua resposta, tente novamente mais tarde.',

  ValidateMinName: 'Mínimo de 2 caracteres',
  ValidatePasswordNotEquals: 'As senhas não são iguais',
  ValidateOnlyNumbers: 'Somente números',

  ERROR_ACCESS_DENIED: 'Acesso negado.',
  ERROR_UNEXPECTED: 'Algo de errado aconteceu.',
  ERROR_NO_AUTHORIZATION: 'Sem autorização.',
  ERROR_DATA_NOT_FOUND: 'Dados não encontrados',
  INFO_DATA_NOT_FOUND: 'Acesse o Game novamente ou entre em contato com o suporte.',
  "You don't have permission to access this page.": 'Você não tem permissão para acessar essa página.',

  'Create Account': 'Cria sua conta',
  'create account': 'crie sua conta',
  'Signup to access the game': 'Cadastra-se para acessar o jogo',
  'signup to access the game': 'cadastra-se para acessar o jogo',
  'To get start now': 'Para começar',
  'Game code': 'Código do game',
  'First access ?': 'Primeiro acesso?',
  Register: 'Cadastre-se aqui',
  'Already have an account?': 'Já criou seu login?',
  'Game code should have 6 characters at least': 'O código do game tem 6 caracteres',
  'Confirm the password': 'Confirme a sua senha',
  'Full name is required': 'Preencha seu nome completo',
  'your credentials': 'suas credenciais',
  'Save or print it to login': 'Salve ou tire um print',
  'Invalid reCaptcha': 'reCaptcha inválido',
  'Game not found': 'Game não encontrado',
  'Players list not found': 'Nenhuma lista de jogadores encontrado',
  'Player not found': 'Jogador não encontrado',
  'Team not found': 'Time não encontrado',
  'Welcome Back !!!': 'Bem-vindo(a)',
  'welcome back !!!': 'bem-vindo(a)',
  'Or sign in to your account': 'Ou faça seu login',
  'Password confirmation': 'Confirmação da senha',
  'Enter with your e-mail': 'Entre com seu e-mail',
  'Full name': 'Nome completo',
  'Game code is required': 'Informe o código do jogo',
  'Or Login': 'Ou faça seu login',
  'This is your team': 'Esse é seu time',
  'This is your login': 'Esse é seu login',
  'This is your password': 'Essa é sua senha',
  Next: 'Próximo',
  'We would like your Full name, please': 'Insira como cadastrado na base de dados da sua empresa',
  'This code was sent along with game link': 'Esse código foi enviado junto com o link do jogo',
  nickname: 'crie seu login',
  'Create your password': 'Crie sua senha',
  'Nickname is required': 'Login é obrigatório',
  'TIP: TAKE A SCREENSHOT AND USE THEM WHENEVER YOU NEED TO ACCESS THE GAME AGAIN': 'DICA: FAÇA UM PRINT E TENHA EM MÃOS SEMPRE QUE FOR ACESSAR O GAME',
  'I need help !!!': 'Eu preciso de ajuda',
  'Create your nickname': 'Crie seu login',
  'Passwords confirmation is required': 'Confirme sua senha para continuar',
  Support: 'Ajuda',
  'Can you help us identify you correctly?': 'Pode nos ajudar a te identificar corretamente?',
  'Select the option that corresponds to your registration': 'Selecione a opção que corresponde ao seu cadastro.',
  'Hi, do you already create an account?': 'Você já criou seu login para esse jogo?',
  'Select a game': 'Selecione um jogo',
  'If not, click on the button below to register': 'Se não, clique no botão abaixo para se cadastrar',
  'Return to login': 'Voltar para o login',
  'Do you save your credentials?': 'Você salvou seus dados de acesso?',
  'Remember, your login / email to access is:': 'Lembre-se, seu login / e-mail para acesso é:',
  'Enter the login you created for this game': 'Digite o login que você criou para esse jogo',
  'Please fill in the fields below': 'Por favor, preencha os campos abaixo',
  'Please, signup below': 'Você precisa se cadastrar abaixo',
  'Ooops, I think you put the wrong password': 'Oops, você digitou sua senha ou email incorreto :(',
  'Please, try again': 'Por favor, tente novamente',
  'Ooops, I think you put the wrong password again': 'Oops, você colocou uma senha errada novamente.',
  'If you need help, please contact us': 'Se precisar de ajuda, nos envie uma mensagem!!',
  'Password attempts exceeded': 'Tentativas de senha excedidas, tente novamente daqui alguns minutos',
  'Check your Login': 'Verifique se digitou corretamente.',
  ERROR_GAME_NOT_FOUND: 'Ooops!! Vamos recomeçar.',
  INFO_GAME_NOT_FOUND: 'Por favor, escaneie novamente o QR CODE ou acesse o link do game.',
  PASS_REQUIREMENTS: 'No mínimo 8 caracteres contendo: 1 número, 1 letra maiúscula e 1 caractere especial (ex: @,#,!,*).',
  NotAuthorizedException: 'Usuário / Senha incorretos',
  'Incorrect username or password.': 'Usuário / Senha incorretos',
  UserNotFoundException: 'Este usuário não existe.',
  'User does not exist.': 'Este usuário não existe.',
  UserNotConfirmedException: 'O usuário ainda não foi confirmado.',
  'User is not confirmed.': 'O usuário ainda não foi confirmado.',
  PasswordResetRequiredException: 'Redefinição de senha necessária: é necessário redefinir a senha do usuário.',
  'Password reset required for the user.': 'Redefinição de senha necessária: é necessário redefinir a senha do usuário.',
  InvalidPasswordException: 'Senha inválida: a senha não está em conformidade com a política de senha.',
  'Password does not conform to policy:...': 'Senha inválida: a senha não está em conformidade com a política de senha.',
  CodeMismatchException: 'Código inválido: foi fornecido um código de verificação inválido.',
  'Invalid verification code provided...': 'Código inválido: foi fornecido um código de verificação inválido.',
  ExpiredCodeException: 'Código expirado: código inválido fornecido, por favor, solicite um novo.',
  'Invalid code provided, please request a new one.': 'Código expirado: código inválido fornecido, por favor, solicite um novo.',
  LimitExceededException: 'Limite excedido: limite de tentativas excedido, tente novamente após algum tempo.',
  'Attempt limit exceeded, please try after some time.': 'Limite excedido: limite de tentativas excedido, tente novamente após algum tempo.',
  InternalErrorException: 'Erro interno: ocorreu um erro interno.',
  'Internal error occurred.': 'Erro interno: ocorreu um erro interno.',
  ServiceUnavailableException: 'Serviço indisponível: o serviço está temporariamente indisponível, tente novamente mais tarde.',
  'Service is temporarily unavailable, please try again later.': 'Serviço indisponível: o serviço está temporariamente indisponível, tente novamente mais tarde.',
  NetworkError: 'Erro na rede.',
  or: 'ou',
  Undo: 'Desfazer',
  'Click to select this item': 'Clique para selecionar.',
  APPROVAL_MODE_INSTRUCTIONS: 'Olá, você recebeu esse game para aprovar!',
  Today: 'Hoje',
  Comments: 'Comentários',
  'Enter here your improvement suggestion or comment.': 'Digite aqui a sugestão de melhoria ou comentário.',
  'Reply or add a comment...': 'Responda ou adicione um comentário...',
  'Enter your name please': 'Digite seu nome por favor',
  Now: 'Agora',
  'Leave a comment...': 'Deixe um comentário...',
  Previous: 'Anterior',
  'You are in approval mode': 'O game está no modo de aprovação',
  'Please, leave a review or approve this mission to go ahead :)': 'Por favor, deixe um comentário ou aprove esta missão para continuar.',
  'It is impossible to revert to the initial missions': 'Ops!! É impossível retornar para as missões iniciais',
  ATTEMPTS_TRIGGER_NAME: 'Feedback de Tentativas',
  CORRECT_ANSWER_TRIGGER_NAME: 'Feedback após resposta',
  TIMEOUT_TRIGGER_NAME: 'Feedback do Cronômetro',
  TRANSITION_TRIGGER_NAME: 'Popup de Transição após feedback',
  WRONG_ANSWER_TRIGGER_NAME: 'Feedback de Resposta Incorreta',
  DEFAULT_TRIGGER_NAME: 'Acionador Padrão',
  'Review the following screens by commenting or approving each mission.': 'Revise as telas a seguir comentando ou aprovando cada missão.',
  'Enter your name:': 'Digite seu nome:',
  Start: 'Iniciar',
  'Leave a review by clicking here.': 'Deixe um comentário clicando aqui.',
  'Approve this mission without a review by clicking here.': 'Aprove diretamente clicando aqui.',
  pending: 'Pendente',
  resolved: 'Resolvido',
  approved: 'Aprovado',
  'We will send you a confirmation e-mail.': 'Enviamos um e-mail de confirmação para você.',
  'Account activation': 'Ativação de conta',
  'We were unable to confirm your account, please contact support.': 'Não foi possível confirmar sua conta.',
  'To update your actvation token, insert your e-mail:': 'Para solicitar um novo token, digite seu email abaixo:',
  'Hello, you are invited to join this game': 'Olá, crie seu cadastro ou faça login para acessar',
  'Your Team': 'Seu time é',
  'Click here to login': 'clique aqui para fazer login',
  'By checking this box, you are agreeing to our terms of service': 'Clique na caixa abaixo se você aceita nossos termos de serviço',
  'Click here to read the Use Terms and Conditions': 'Clique aqui para ler os termos de uso e condições',
  'This email already exists': 'Ops, esse e-mail já está cadastrado!! Faça o login para continuar',
  'You account has been activated': 'Sua conta foi ativada com sucesso!! Agora você pode fazer login',
  'User not found': 'Usuário não encontrado',
  'Invitation link not found or expired': 'Link de convite não encontrado ou expirado.',
  'Sending...': 'Enviando...',
  'Go to login': 'Ir para login',
  'Thank you, check your e-mail': 'Verifique seu e-mail para continuar.',
  'Player not found.': 'Ops, usuário não cadastrado nesse game.',
  'Unauthorized email': 'Ops, esse e-mail não está autorizado para acessar esse game.',
  'Ops, your account is still disabled, please check your e-mail.': 'Sua conta ainda está desativada, por favor, verifique seu e-mail.',
  'User is disabled.': 'E-mail não confirmado',
  Return: 'Voltar',
  'Your e-mail has been disabled to receive notifications': 'Seu e-mail foi desativado para receber notificações',
  'Points will be awarded after content verification.': 'Pontos serão atribuídos após a verificação do conteúdo.',
  'Record audio': 'Gravar áudio',
  'Audio description': 'Descrição do áudio',
  'Drag or paste your audio file here': 'Arraste ou cole um arquivo de áudio aqui',
  'User needs to be authenticated to call this API.': 'Bem vindo, para continuar faça seu login.'
}
